"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const UpdateDay2ApiVipForm_1 = tslib_1.__importDefault(require("./UpdateDay2ApiVipForm"));
const UpdateDay2ApiVipModal = (_a) => {
    var { isOpen, onClose } = _a, props = tslib_1.__rest(_a, ["isOpen", "onClose"]);
    return (react_1.default.createElement(react_core_1.Modal, { "aria-label": "Update cluster hostname", title: "Update cluster hostname", isOpen: isOpen, variant: react_core_1.ModalVariant.small, hasNoBodyWrapper: true, onClose: onClose },
        react_1.default.createElement(UpdateDay2ApiVipForm_1.default, Object.assign({}, props, { onClose: onClose }))));
};
exports.default = UpdateDay2ApiVipModal;
//# sourceMappingURL=UpdateDay2ApiVipModal.js.map